export default "__VITE_ASSET__BMnlo5Bz__"